'use client';

import React from 'react';
import {
  IText,
  TTypographyColor,
  Typography,
} from '@/components/atoms/Typography/Typography';
import * as Styled from './Button.styled';

interface IButton extends IText {
  hoverColor?: TTypographyColor;
  backgroundColor?: TTypographyColor;
  callbackOnClick?: () => void;
  scaleOnHover?: boolean;
  className?: string;
  inverseRow?: boolean;
  buttonTitle?: string;
  children?: React.ReactNode;
}
export const Button: React.FC<IButton> = ({
  className,
  text = '',
  size = 'default',
  color = 'default',
  // hoverColor = 'default',
  backgroundColor,
  lineHeight = 'default',
  fontFamily = 'default',
  scaleOnHover = false,
  inverseRow = false,
  buttonTitle = '',
  children,
  callbackOnClick,
  ...props
}) => {
  return (
    <Styled.Button
      className={className}
      scaleOnHover={scaleOnHover}
      onClick={callbackOnClick}
      color={color}
      {...(backgroundColor && { backgroundColor: backgroundColor })}
      inverseRow={inverseRow}
      {...(buttonTitle && { title: buttonTitle })}
      {...props}
    >
      {children}
      {text && (
        <Typography
          text={text}
          size={size}
          color={color}
          lineHeight={lineHeight}
          fontFamily={fontFamily}
          as="span"
        />
      )}
    </Styled.Button>
  );
};
